import { DEFAULT_PROFILE_KEY } from "./resolveUserPermissions";

export function countProfileFieldDiffs(baseProfile, currentProfile) {
  let count = 0;

  Object.entries(currentProfile?.featureFlags ?? {}).forEach(([key, value]) => {
    if (baseProfile?.featureFlags?.[key] !== value) {
      count += 1;
    }
  });

  const currentActions = currentProfile?.actionFlags ?? currentProfile?.tableActions ?? {};
  const baseActions = baseProfile?.actionFlags ?? baseProfile?.tableActions ?? {};

  Object.entries(currentActions).forEach(([group, actions]) => {
    Object.entries(actions ?? {}).forEach(([action, value]) => {
      if (baseActions?.[group]?.[action] !== value) {
        count += 1;
      }
    });
  });

  return count;
}

export function getPermissionsChangeCount(baselineRegistry, currentRegistry) {
  const baseline = baselineRegistry ?? {};
  const current = currentRegistry ?? {};
  let count = 0;

  Object.keys(baseline).forEach((email) => {
    if (!(email in current)) {
      count += 1;
    }
  });

  Object.keys(current).forEach((email) => {
    if (!(email in baseline)) {
      count += 1;
      return;
    }
    count += countProfileFieldDiffs(baseline[email], current[email]);
  });

  return count;
}

export function isEmailAdded(baselineRegistry, currentRegistry, email) {
  return Boolean(currentRegistry?.[email]) && !(email in (baselineRegistry ?? {}));
}

export function isEmailDeleted(baselineRegistry, currentRegistry, email) {
  return Boolean(baselineRegistry?.[email]) && !(email in (currentRegistry ?? {}));
}

export function isFeatureFlagModified(baselineRegistry, currentRegistry, email, key) {
  if (isEmailAdded(baselineRegistry, currentRegistry, email)) {
    return true;
  }
  const baseline = baselineRegistry?.[email];
  if (!baseline) {
    return false;
  }
  return baseline.featureFlags?.[key] !== currentRegistry?.[email]?.featureFlags?.[key];
}

export function isActionFlagModified(baselineRegistry, currentRegistry, email, group, action) {
  if (isEmailAdded(baselineRegistry, currentRegistry, email)) {
    return true;
  }
  const baseline = baselineRegistry?.[email];
  if (!baseline) {
    return false;
  }
  const baselineActions = baseline.actionFlags ?? baseline.tableActions ?? {};
  const currentActions = currentRegistry?.[email]?.actionFlags
    ?? currentRegistry?.[email]?.tableActions
    ?? {};
  return baselineActions?.[group]?.[action] !== currentActions?.[group]?.[action];
}

export function isEmailModified(baselineRegistry, currentRegistry, email) {
  if (isEmailAdded(baselineRegistry, currentRegistry, email)) {
    return true;
  }
  if (isEmailDeleted(baselineRegistry, currentRegistry, email)) {
    return true;
  }
  const baseline = baselineRegistry?.[email];
  const current = currentRegistry?.[email];
  if (!baseline || !current) {
    return false;
  }
  return countProfileFieldDiffs(baseline, current) > 0;
}

export function formatPermissionsChangeCount(count) {
  if (count <= 0) {
    return "Nessuna modifica";
  }
  return count === 1 ? "1 modifica non salvata" : `${count} modifiche non salvate`;
}

export function isDefaultProfileKey(key) {
  return key === DEFAULT_PROFILE_KEY;
}
